"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run_breach = void 0;
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
function run_breach() {
    voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.hitByWeapon(0.9, 0, 100);
}
exports.run_breach = run_breach;
